import styled from "styled-components";
import { WidgetStyle } from "../widgetStyle";
import { Flex } from "@components/flex/flex";

export const CarousselWidgetStyle = styled(WidgetStyle)`
     .carousselModeSwitch {
        margin: 14px 0;

        & .ant-select {
            margin-top: 10px;
        }
    }

    .tabscover {
        position: relative;
    }

    .dropDownCarousselPicker {
        border: none;
        box-shadow: none;
        padding-right: 0;
        margin: 15px 0;
        position: relative;
        width: 100%;
        background: #A0C63D;
        color: #FFFFFF;

        &:hover, &:focus {
            background: #A0C63D;
            color: #FFFFFF;
        }
    }

    ${Flex} {
        .ant-form-item {
            width: 100%;
        }
    }
`;

export interface CarousselPaneProps {
    hidden?: boolean;
}

export const CarousselPane = styled.div<CarousselPaneProps>`
    display: ${props => props.hidden ? "none" : "flex"};
    flex-direction: column;
`;

export const CarousselWidgetPaneStyle = styled.div`
    h3 {
        color: #A0C63D;
        margin: 15px 0 0 0;
        font-weight: 600;
    }

    .ant-row + .ant-row {
        margin-left: 0 !important;
    }
`;
